import { Box, Flex } from '@pancakeswap/uikit'
import { styled } from 'styled-components'

export const StyledSwapContainer = styled(Flex)<{ $isChartExpanded: boolean }>`
  position: relative;
  flex-shrink: 0;
  height: fit-content;
  width: calc(100vw - 2em);
  max-width: 436px;
  padding: 1em;
  margin-bottom: 15px;
  z-index: 1;
  border-radius: 25px;
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};
  background: ${({ theme }) => theme.colors.backgroundAlt};
  box-shadow: 0 24px 64px -24px rgba(0, 0, 0, 0.75), 0 0 0 1px rgba(139, 92, 246, 0.04),
    inset 0 1px 0 rgba(255, 255, 255, 0.04);
  transition: box-shadow 300ms ease, border-color 300ms ease;

  /* Gradient hairline on top of the card — a real 1px border can't hold a
     gradient, so it lives in a masked pseudo-element instead. */
  &::before {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: inherit;
    padding: 1px;
    background: linear-gradient(140deg, rgba(139, 92, 246, 0.55), rgba(139, 92, 246, 0) 42%, rgba(167, 139, 250, 0.35));
    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor;
    mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    mask-composite: exclude;
    pointer-events: none;
    opacity: 0.9;
  }

  &:hover {
    border-color: rgba(139, 92, 246, 0.28);
    box-shadow: 0 32px 72px -24px rgba(0, 0, 0, 0.8), 0 0 0 1px rgba(139, 92, 246, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.06);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`

export const StyledInputCurrencyWrapper = styled(Box)`
  width: 100%;
`
